/**
 * Menu da sidebar do konq-ui, em seções (mesmo formato do konq-backoffice).
 *
 * Visibilidade de cada item (ver `useMenuVisivel` em Sidebar.jsx):
 * - `capability`: exige a capability concedida pelo backend (Master vê tudo).
 * - `forTipo`: item de um papel específico ('produtor' | 'jurado'). Roles de backoffice
 *   sem impersonar só veem itens sem `forTipo`; impersonando, vale o tipo escolhido.
 * - `requireBootstrapFlag`: flag do `concursoAtivo` do bootstrap que precisa ser true.
 *
 * `label` é chave do i18n.
 */
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';

export const menuSections = [
  {
    title: 'General',
    items: [{ path: '/dashboard', label: 'Dashboard', icon: DashboardOutlinedIcon }],
  },
  {
    title: 'Event',
    items: [
      {
        path: '/inscricoes',
        label: 'Products Registrations',
        icon: AssignmentOutlinedIcon,
        capability: 'inscricoes.listar',
        forTipo: ['produtor'],
      },
      // "Contest Results" fica fora do menu até algum concurso publicar resultados.
      // A rota /resultados e a flag `resultadosPublicados` continuam prontas:
      // { path: "/resultados", label: "Contest Results", icon: EmojiEventsOutlinedIcon,
      //   capability: "resultados.visualizar", requireBootstrapFlag: "resultadosPublicados",
      //   forTipo: ["jurado", "produtor"] },
    ],
  },
  {
    title: 'Judge',
    items: [
      {
        path: '/jurado',
        label: 'My evaluations',
        icon: RateReviewOutlinedIcon,
        capability: 'avaliacoes.listar',
        forTipo: ['jurado'],
      },
    ],
  },
];
